import React from "react";
import { Check } from "lucide-react";
import { whyChoose } from "../mock/mock";

const WhyChoose = () => {
  return (
    <section className="section-pad grid-dots border-b-2 border-[#0A0A0A]">
      <div className="container-x grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative order-2 lg:order-1">
          <div className="border-2 border-[#0A0A0A] shadow-[10px_10px_0_#0A0A0A]">
            <img src={whyChoose.image} alt="Why choose Infinity Solutions" className="w-full h-[440px] object-cover bw" />
          </div>
          <div className="absolute -top-5 -right-5 bg-[#0A0A0A] text-[#F4F1EA] px-6 py-4 border-2 border-[#0A0A0A]">
            <p className="display text-3xl font-extrabold">98%</p>
            <p className="mono text-[11px] uppercase tracking-widest">Satisfaction</p>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <p className="eyebrow text-neutral-500">/ Why Us</p>
          <h2 className="mt-4 display text-4xl md:text-5xl font-extrabold uppercase leading-[0.95]">
            Why Businesses <span className="hl">Choose Us</span>
          </h2>
          <p className="mt-5 text-neutral-700 leading-relaxed">
            We combine cutting-edge technology, elite pre-vetted talent, and flexible engagement models to
            deliver measurable results.
          </p>
          <ul className="mt-8 divide-y-2 divide-[#0A0A0A] border-y-2 border-[#0A0A0A]">
            {whyChoose.points.map((p) => (
              <li key={p} className="flex items-start gap-4 py-4">
                <span className="w-6 h-6 shrink-0 border-2 border-[#0A0A0A] flex items-center justify-center mt-0.5" style={{ background: "var(--accent)" }}>
                  <Check size={14} strokeWidth={3} />
                </span>
                <span className="text-neutral-800">{p}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
